import React from "react";
import "./GetMusicOnTidal.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnTidal = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select TIDAL distribution",
    "Release approved by stores",
    "Go live worldwide",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on TIDAL | Hi-Fi Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to TIDAL with FT Tunes. Reach premium listeners worldwide with Hi-Fi lossless audio streaming and maximize your music revenue."
        />

        <meta
          name="keywords"
          content="TIDAL distribution, upload music to TIDAL, HiFi music streaming distribution, TIDAL music distribution, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="tidal-page">

        {/* HERO */}
        <section className="tidal-hero">
          <Container>

            <img
              src="/Images/tidal-logo.png"
              alt="TIDAL Distribution"
              className="tidal-logo"
            />

            <h1>Get Your Music on TIDAL</h1>

            <p>
              Release your music on TIDAL and reach premium listeners
              worldwide through Hi-Fi and Master Quality streaming.
              Deliver studio-quality sound and grow your global audience.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-tidal"></div>
        </section>


        {/* SHOWCASE */}
        <section className="tidal-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Premium Streaming Experience</h2>

                <p>
                  TIDAL focuses on artist-first streaming with lossless
                  audio quality, exclusive content, and higher value
                  listeners who appreciate premium music experiences.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-tidal.png"
                  alt="TIDAL Platform"
                  className="tidal-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="tidal-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="tidal-benefits">
          <Container>

            <h2 className="section-title">
              Why Artists Choose TIDAL
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Hi-Fi Audio</h5>
                  <p>Lossless studio-quality streaming.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Premium Audience</h5>
                  <p>Reach serious music listeners globally.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Artist Focused</h5>
                  <p>Designed to support artists first.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Keep Ownership</h5>
                  <p>You retain 100% rights to your music.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="tidal-cta">
          <Container>

            <h2>Release Your Music on TIDAL Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnTidal;